import React from 'react';
import { Icon } from 'semantic-ui-react';

import clsx from 'clsx';

const EmailIcon = ({
  className,
  email,
  icon = 'user outline',
  name,
}) => (
  <a
    className={clsx('aridhia-email-icon', className)}
    href={`mailto:${email}`}
    target="_blank"
    rel="noopener noreferrer"
  >
    <Icon name={icon} />
    {name}
  </a>
);

export default EmailIcon;
